import {CustomAxiosError, useApiCalls} from "../../../../../logics/api_config";
import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {useAuth} from "../../../../../utils/contexts/auth-context";
import {IVatCode} from "../../../../../utils/interfaces/my_documents/IVatCode";


const useApiGetVatCode = (pk: number | undefined): UseQueryResult<IVatCode, CustomAxiosError> => {
    const {selectedCompany} = useAuth();
    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IVatCode> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/my_documents/vat_code/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetVatCode", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk
    })
};

export default useApiGetVatCode